import getConfig from 'next/config'

const {publicRuntimeConfig} = getConfig()
export const {
  WS_HOST,
  SITE_HOST,
  STATIC_HOST,
  API_HOST,
  DEPLOY_ENV,
  COMMIT,
  SPEED_SITE
} = publicRuntimeConfig

export const WS_ROOT = `${WS_HOST}/stream`
export const LOGIN_PRURL = __DEV__ ? 'http://localhost:3000/login-local' : '/$locale/login'
export const REGISTER_URL = __DEV__ ? 'http://localhost:3000/register' : '/$locale/register'
export const USER_CENTER_URL = '/$locale/usercenter/dashboard/overview'
export const __PROD__ = DEPLOY_ENV === 'prod'
export const isTestnet = SITE_HOST.includes('.binancefuture.')
export const isMainProd = SITE_HOST.includes('.binance.') || SITE_HOST.includes('.binance-cn.')

export const DATE_FORMATTER = 'YYYY-MM-DD HH:mm:ss'
export const TICK_SIZE = 1e-2
export const DECIMAL_PLACE = 2
export const QTY_DECIMAL_PLACE = 3
export const API_DOC = 'https://binanceapitest.github.io/Binance-Future-API-test-doc/'
export const SITE_TITLE = 'Binance Futures'
export const SENSOR_PROJECT = __PROD__ && !isTestnet ? 'binance' : 'default'
export const CONTRACT_MULTIPLIER = 1

export const HELP_URL = {
  en: 'https://binance.zendesk.com/hc/en-us/categories/360001987372-Futures-Contracts',
  cn:
    'https://binance.zendesk.com/hc/zh-cn/categories/360001987372-%E5%90%88%E7%BA%A6%E4%BA%A4%E6%98%93',
  ru: 'https://binance.zendesk.com/hc/ru/categories/360001987372-Futures-Contracts',
  vn: 'https://binance.zendesk.com/hc/vi/categories/360001987372-Futures-Contracts'
}

export const FEE_DETAIL = {
  en: '//www.binance.com/en/support/articles/360033544231',
  cn: '//binance.zendesk.com/hc/zh-cn/articles/360033544231'
}

export const FUTURES_URL = 'futures/BTCUSDT'
export const FUNDING_HISTORY_URL = 'futures/funding-history'

export const TRADE_TYPES = {
  LIMIT: 'limit',
  MARKET: 'market',
  STOP: 'stop',
  TAKE_PROFIT: 'takeProfit',
  CLOSE: 'close'
}

export const LIMIT_TYPES = {
  POST_ONLY: 'POST_ONLY',
  REDUCE_ONLY: 'REDUCE_ONLY',
  TIF: 'TIF'
}

export const TIME_IN_FORCE = {
  POST_ONLY: 'GTX',
  TIF: {
    GTC: 'GTC',
    IOC: 'IOC',
    FOK: 'FOK'
  }
}

export const TRADE_SIDES = {
  BUY: 'buy',
  SELL: 'sell'
}

export const SETTING = {
  transferAvailable: !isTestnet,
  openAccountAvailable: !isTestnet,
  feeAvailable: !isTestnet,
  enableReduceOnly: true,
  enableTakeProfit: true,
  enableFundingHistory: !isTestnet,
  leverageInfo: {
    symbol: 'x',
    defaultVal: 20,
    minVal: 1,
    maxVal: 125,
    avaliableVal: 40,
    minNationalVal: 50000,
  },
  slideFlag: !isMainProd
}

export const DIALOGS = {
  TRANSFER_DIALOG: 'transfer_dialog',
  OPEN_ACCOUNT: 'open_account_dialog',
  LEVERAGE_DIALOG: 'leverage_dialog',
}

export const DATA_MAP = {
  NEW: '新开仓',
  FILLED: '已成交',
  CANCELED: '已撤销',
  EXPIRED: '已过期',
  PARTIALLY_FILLED: '部分成交',
  REJECTED: '已拒绝',
  LIMIT: '限价单',
  MARKET: '市价单',
  STOP: '止损单',
  'STOP LIMIT': '止损单',
  BUY: '买入',
  SELL: '卖出',
  COMMISSION: '手续费',
  REALIZED_PNL: '已实现盈亏',
  FUNDING_FEE: '资金费用',
  TRANSFER: '资金划转',
  LIQUIDATION: '强平单',
  TAKE_PROFIT: '止盈单',
  INSURANCE_CLEAR: '爆仓扣款'
}
